import { useState, useEffect } from "react";
import styles from "./QuizCard.module.css";

export default function QuizCard({ question, selected, setSelected, handleNext }) {
  const [answered, setAnswered] = useState(false);

  // Auto-advance after 1 second when answered
  useEffect(() => {
    if (!answered) return;
    const timer = setTimeout(() => {
      setAnswered(false);
      handleNext();
    }, 1000);
    return () => clearTimeout(timer);
  }, [answered]);

  const options = [
    question.option_1,
    question.option_2,
    question.option_3,
    question.option_4,
  ];

  const handleOptionClick = (index) => {
    if (answered) return;
    setSelected(index + 1);
    setAnswered(true);
  };

  const getOptionStyle = (index) => {
    const optionNumber = index + 1;
    if (!answered) return styles.option;
    if (optionNumber === question.correctAnswer) return `${styles.option} ${styles.correct}`;
    if (optionNumber === selected) return `${styles.option} ${styles.wrong}`;
    return `${styles.option} ${styles.dimmed}`;
  };

  return (
    <>
      <div className={styles.questionBox}>
        <h2>{question.title}</h2>
      </div>

      <div className={styles.options}>
        {options.map((option, index) => (
          <button
            key={index}
            className={getOptionStyle(index)}
            onClick={() => handleOptionClick(index)}
            disabled={answered}
          >
            <span className={styles.optionLabel}>{index + 1})</span>
            <span className={styles.optionText}>{option}</span>
            {answered && index + 1 === question.correctAnswer && (
              <span className={styles.icon}>✓</span>
            )}
            {answered && index + 1 === selected && selected !== question.correctAnswer && (
              <span className={styles.icon}>✗</span>
            )}
          </button>
        ))}
      </div>

      {answered && (
        <div className={styles.feedbackBar}>
          {selected === question.correctAnswer ? (
            <span className={styles.feedbackCorrect}>🎉 Correct! +5 points</span>
          ) : (
            <span className={styles.feedbackWrong}>❌ Wrong answer</span>
          )}
        </div>
      )}
    </>
  );
}